import type { DomainNameserver } from '@fourthwall/services/dist/DnsApiClient/models'

import { nameserversToDnsProviders } from '../consts'

export const getIllegalDnsProvider = (nameservers: DomainNameserver[] | undefined) => {
  const illegalNameserver = nameservers?.find((ns) => !ns.isMxSupported)?.name
  if (illegalNameserver) {
    return (
      nameserversToDnsProviders.find((it) => illegalNameserver.includes(it.nameserver))
        ?.dnsProvider || illegalNameserver
    )
  }

  return null
}
